"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    initialAmount: _propTypes.default.number.isRequired,
    discountAmount: _propTypes.default.number,
    currencyCode: _propTypes.default.string.isRequired,
    isLoading: _propTypes.default.bool,
    isEnabled: _propTypes.default.bool,
    onClickApply: _propTypes.default.func,
    showLoaderWhenClicked: _propTypes.default.bool,
    hasTopBorder: _propTypes.default.bool,
    translations: {
      savedDesc: _propTypes.default.string,
      totalAmount: _propTypes.default.string
    },
    isMobile: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    initialAmount: 0,
    discountAmount: 0,
    currencyCode: 'MYR',
    isLoading: false,
    showLoaderWhenClicked: false,
    hasTopBorder: true,
    isEnabled: true,
    translations: {
      savedDesc: "Saved {0}",
      totalAmount: "Total Amount"
    },
    isMobile: false
  }
};
exports.default = _default;